export const sort = (array: any[], reverse: boolean, prop?: string) => {
  const sortArray = array.sort((a: any, b: any) => {
    if (prop) {
      if (a[prop].toString().toLowerCase() > b[prop].toString().toLowerCase()) {
        return 1;
      }
      if (a[prop].toString().toLowerCase() < b[prop].toString().toLowerCase()) {
        return -1;
      }
      return 0;
    } else {
      if (a > b) {
        return 1;
      }
      if (a < b) {
        return -1;
      }
      return 0;
    }
  });
  return reverse ? sortArray.reverse() : sortArray;
};

export const removeItem = (array: any, valueToRemove: any, prop?: string) => {
  if (prop) {
    return array.filter((item: any) => item[prop] !== valueToRemove);
  }
  return array.filter((item: any) => item !== valueToRemove);
};
